//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React from 'react';
import { useSelector } from 'react-redux';

import { NavMenuItem } from '@legacy-components/nav3/navigation-menus/NavMenuItem';
import { NAV_MENU_ITEMS_TRACKING_ID } from '@legacy-components/nav3/navigation-menus/constants/NavMenuItemConstants';
import { getIsListeningEnabled } from '@listening/selectors/getIsListeningEnabled';

import { NavGroup } from 'app/initialization/routing/stateHelpers';

export const ListeningNav = () => {
  const isListeningEnabled = useSelector(getIsListeningEnabled);

  if (!isListeningEnabled) {
    return null;
  }

  return (
    <NavMenuItem
      activeNavGroup={NavGroup.LISTENING}
      state='listening'
      trackingId={NAV_MENU_ITEMS_TRACKING_ID.LISTENING_NAV}
    >
      Listening
    </NavMenuItem>
  );
};
